import React from 'react';
import Header from '../components/Header/Header';
import StatsHero from '../components/StatsHero/StatsHero';
import Footer from '../components/Footer/Footer';
import DataPower from '../components/DataPower/DataPower';
import FooterCTA from '../components/FooterCTA/FooterCTA';
import DeliveryMode from '../components/DeliveryMode/DeliveryMode';
import Regions from '../components/Regions/Regions';
import Infographics from '../components/Infographics/Infographics';
import DataBankCTA from '../components/DataBankCTA/DataBankCTA';
import GranularData from '../components/GranularData/GranularData';
import CustomDashboards from '../components/CustomDashboards/CustomDashboards';
import Workflow from '../components/Workflow/Workflow';
import HistoricalDataCTA from '../components/HistoricalDataCTA/HistoricalDataCTA';
import PlatformAdvantages from '../components/PlatformAdvantages/PlatformAdvantages';

const DataStatsPage = () => {
  return (
    <>
      <Header />
      <main>
        <StatsHero />
        <Regions />
        <Infographics />
        <GranularData />
        <DataBankCTA />
        <CustomDashboards />
        <Workflow />
        <HistoricalDataCTA />
        <PlatformAdvantages />
        <DeliveryMode />
        <DataPower />
        <FooterCTA /> 
      </main>
      <Footer />
    </>
  );
};

export default DataStatsPage;